import React from 'react'
import PropTypes from 'prop-types'
import Drawer from '../ui/Drawer'
import EmptyState from '../ui/EmptyState'
import Loader from '../shared/Loader'
import { useSectionDetails } from './hooks'
import QuestionList from './QuestionList'
import DrawerInfoBanner from '../shared/DrawerInfoBanner'
import { SECTION_EMPTY_MESSAGE, VIEW_MODES } from './constants'

const drawerTitleFor = section => {
  if (!section)
    return 'Détails par question'
  return `Détails par question de la section ${section.name}`
}

const SectionDrawer = ({
  collectId, draftId, sectionId, section, onClose, dateRange,
  viewMode, gradeMax, resourceIds, resourcesHref
}) => {
  const isOpen = Boolean(sectionId)
  const { details, loading, error } = useSectionDetails({
    collectId, draftId, sectionId, dateRange, resourceIds
  })
  const showContent = Boolean(details) && !loading
  const isEmpty = showContent && details.questions.length === 0

  return (
    <Drawer
      ariaLabel="Détails par question de la section"
      isOpen={isOpen}
      onClose={onClose}
    >
      <Drawer.Header onClose={onClose}>{drawerTitleFor(section)}</Drawer.Header>
      <Drawer.Body>
        {details?.has_photo_or_comment ? <DrawerInfoBanner resourcesHref={resourcesHref} /> : null}
        {loading ? <Loader /> : null}
        {error ? (
          <div className="tw:p-3 tw:bg-red-50 tw:text-red-700 tw:rounded-md!">
            Une erreur est survenue lors du chargement.
          </div>
        ) : null}
        {isEmpty ? <EmptyState message={SECTION_EMPTY_MESSAGE} /> : null}
        {showContent && !isEmpty ? (
          <QuestionList
            gradeMax={gradeMax}
            questions={details.questions}
            viewMode={viewMode}
          />
        ) : null}
      </Drawer.Body>
    </Drawer>
  )
}

SectionDrawer.propTypes = {
  collectId: PropTypes.number.isRequired,
  dateRange: PropTypes.shape({
    endDate: PropTypes.string,
    startDate: PropTypes.string
  }),
  draftId: PropTypes.number,
  gradeMax: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  resourceIds: PropTypes.arrayOf(PropTypes.number),
  resourcesHref: PropTypes.string.isRequired,
  section: PropTypes.shape({
    grade: PropTypes.number,
    // eslint-disable-next-line camelcase
    has_grade_questions: PropTypes.bool,
    id: PropTypes.number,
    name: PropTypes.string,
    // eslint-disable-next-line camelcase
    satisfaction_rate: PropTypes.number
  }),
  sectionId: PropTypes.number,
  viewMode: PropTypes.oneOf(Object.values(VIEW_MODES)).isRequired
}

SectionDrawer.defaultProps = {
  dateRange: null,
  draftId: null,
  resourceIds: [],
  section: null,
  sectionId: null
}

export default SectionDrawer
